import React, {useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'

import {useToastController} from '@vio/atlas/context/toastController'
import {useRouterProvider} from '@vio/core/src/_web/router/context/RouterContext'

import {clearToast} from '../../slice'
import {selectToast} from '../../slice/selectors'
import {
  PriceWatchToastIcon,
  PriceWatchToastMessage
} from '../PriceWatchToastMessage'

/**
 * Global toast listener for price watch feedback.
 * Displays toasts regardless of component lifecycle,
 * solving the virtual list unmounting issue.
 */
export const PriceWatchToastListener: React.FC = () => {
  const dispatch = useDispatch()
  const toastData = useSelector(selectToast)
  const {open, closeAll} = useToastController()
  const {push} = useRouterProvider()

  useEffect(() => {
    if (!toastData) return

    const {
      hotel,
      checkIn,
      checkOut,
      enabled,
      shouldShowNavigationIcon,
      alertsManagementUrl,
      saveFramingIsOn
    } = toastData

    const handleToastClick = () => {
      closeAll()

      // Navigate to alerts management if URL is provided
      if (alertsManagementUrl) {
        push(alertsManagementUrl)
      }
    }

    // Show the toast
    open(
      <PriceWatchToastMessage
        hotel={hotel}
        checkIn={checkIn}
        checkOut={checkOut}
        shouldShowNavigationIcon={shouldShowNavigationIcon}
        enabled={enabled}
        saveFramingIsOn={saveFramingIsOn}
      />,
      {
        // Deliberately no glyph: atlas reflows its padding when `icon` is absent.
        icon: saveFramingIsOn ? undefined : (
          <PriceWatchToastIcon enabled={enabled} />
        ),
        onClick: handleToastClick
      }
    )

    // Immediately clear the toast from state to prevent replay
    dispatch(clearToast())
  }, [toastData, open, closeAll, push, dispatch])

  // This component renders nothing visible
  return null
}
